import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=d242fa20&scoped=true&lang=pug&"
import script from "./upgrade.vue?vue&type=script&lang=js&"
export * from "./upgrade.vue?vue&type=script&lang=js&"
import style0 from "./upgrade.vue?vue&type=style&index=0&id=d242fa20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d242fa20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d242fa20')) {
      api.createRecord('d242fa20', component.options)
    } else {
      api.reload('d242fa20', component.options)
    }
    module.hot.accept("./upgrade.vue?vue&type=template&id=d242fa20&scoped=true&lang=pug&", function () {
      api.rerender('d242fa20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/openapi/dialog/upgrade.vue"
export default component.exports